class GridHelper {
    constructor() {
        this.registerEvents();
    }

    registerEvents() {
        window.addEventListener('keydown', (e) => {
            if (e.ctrlKey && e.keyCode === 71) {
                this.toggleHelper();
            }
        });
    }

    toggleHelper() {
        if (!document.querySelector('.container--overlay-grid')) {
            this.active();
        } else {
            this.destroy();
        }
    }

    active() {
        if (!document.querySelector('.container--overlay-grid')) {
            document.querySelector('body').insertAdjacentHTML('beforeend', `<div class="container container--overlay-grid">
                <div class="grid">
                    <div class="col"><div class="col__inner"></div></div>
                    <div class="col"><div class="col__inner"></div></div>
                    <div class="col"><div class="col__inner"></div></div>
                    <div class="col"><div class="col__inner"></div></div>
                    <div class="col"><div class="col__inner"></div></div>
                    <div class="col"><div class="col__inner"></div></div>
                    <div class="col"><div class="col__inner"></div></div>
                    <div class="col"><div class="col__inner"></div></div>
                    <div class="col"><div class="col__inner"></div></div>
                    <div class="col"><div class="col__inner"></div></div>
                    <div class="col"><div class="col__inner"></div></div>
                    <div class="col"><div class="col__inner"></div></div>
                </div>
            </div>`);
            localStorage.setItem('gridHelper', true);

            return `Grid helper active`;
        }
    }
    destroy() {
        if (document.querySelector('.container--overlay-grid')) {
            document.querySelector('.container--overlay-grid').remove();
            localStorage.removeItem('gridHelper');

            return `Grid helper destroyed`;
        } else {
            return `Grid helper not active, nothing to destroy`;
        }
    }
}

const gridHelper = new GridHelper;
window.GridHelper = gridHelper;

if (localStorage.getItem('gridHelper')) {
    gridHelper.active();
}
